<template>
  <div :id="componentId" class="sp-image-component" :style="sectionStyle">
    <div class="sp-image-wrapper" :style="wrapperStyle">
      <div class="sp-image-list" :style="listStyle">
        <img
          v-for="(url, index) in displayImageList"
          :key="index"
          class="sp-image-main"
          referrerpolicy="no-referrer"
          :src="url"
          :style="imageStyle"
        >
      </div>
      <div v-if="!displayImageList.length" class="sp-image-placeholder">
        <i class="el-icon-picture-outline" />
        <span>暂无图片</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpImage',
  props: {
    componentId: {
      type: String,
      default: 'sp_image'
    },
    config: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      imageList: [],
      bgColor: '#ffffff',
      width: 1400,
      imageHeight: 400,
      imageGap: 20
    }
  },
  watch: {
    config: {
      handler(newConfig) {
        if (newConfig) {
          try {
            const parsed = JSON.parse(newConfig)
            this.width = parsed.width || 1400
            this.bgColor = parsed.bgColor || '#ffffff'
            this.imageHeight = parsed.imageHeight || 400
            this.imageGap = parsed.imageGap || 20
            this.imageList = parsed.imageList || []
          } catch (e) {
            console.error('解析 config 失败', e)
          }
        }
      },
      immediate: true
    }
  },
  computed: {
    displayImageList() {
      return (this.imageList || []).map(item => {
        if (typeof item === 'string') return item
        return item && item.url ? item.url : ''
      }).filter(url => url)
    },
    itemWidth() {
      const count = this.displayImageList.length
      if (count <= 1) return '100%'
      const gap = Number(this.imageGap) || 0
      const totalGap = gap * (count - 1)
      return `calc((100% - ${totalGap}px) / ${count})`
    },
    sectionStyle() {
      return {
        backgroundColor: this.bgColor
      }
    },
    wrapperStyle() {
      return {
        width: `${this.width}px`
      }
    },
    listStyle() {
      const gap = Number(this.imageGap) || 0
      return {
        gap: `${gap}px`
      }
    },
    imageStyle() {
      return {
        width: this.itemWidth,
        height: `${this.imageHeight}px`
      }
    }
  },
  methods: {}  // 移除编辑功能
}
</script>

<style scoped>
.sp-image-component {
  position: relative;
  width: 2000px;  /* 默认值，会被组件配置的宽度覆盖 */
  left: 50%;
  transform: translateX(-50%);
  min-height: 200px;
  padding: 40px 0;
  cursor: pointer;
}

.sp-image-wrapper {
  position: relative;
  margin: 0 auto;
  background: transparent;
  border-radius: 4px;
  overflow: hidden;
}

.sp-image-list {
  display: flex;
  align-items: center;
  width: 100%;
}

.sp-image-main {
  display: block;
  flex-shrink: 0;
  object-fit: cover;
}

.sp-image-placeholder {
  width: 100%;
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
  background: #f5f7fa;
}

.sp-image-placeholder i {
  font-size: 60px;
  margin-bottom: 12px;
  color: #c0c4cc;
}
</style>
